import "unorm";
import React from "react";
import { render } from "react-dom";
import App from "components/App";
import { StoreProvider } from "components/StoreContext";

render(
  <StoreProvider>
    <App />
  </StoreProvider>,
  document.getElementById("root")
);
